import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

import {
  Table,
TableBody,
TableCell,
TableContainer,
TableHead,
TableRow,
Paper,
Box,
CircularProgress,
Typography
} from '@mui/material';




const QuarterlyReview = () => {

  const { data: quarterlyReviewData, loading: quarterlyReviewLoading } = useSelector(state => state.quarterlyReviewReducer);

  // console.log('dsa');
    const [QuarterlyReviewData, setQuarterlyReviewData] = useState({header:[], tableBody:[]});

  useEffect(() => {

    if(!quarterlyReviewLoading){
      if(quarterlyReviewData.header && quarterlyReviewData.header.length > 0){

        let header = quarterlyReviewData.header;
        let qData = quarterlyReviewData.Data;
  
        // console.log('quarterlyReviewData >>>> ', qData);
        var mColArr = [];
        var width = 120;
        header.map((head, key)=>{
          var hData = {
            id: head['column'],
            label: head['value'],
            minWidth: width,
            maxWidth: width,
            align: 'canter',
            hideCheck: null,
            sticky: null,
            extra:head
          }
          mColArr.push(hData);
        });
        // console.log('mColArr >> ', mColArr);
  
        var allRowsData_row = [];
        qData.map((item, key)=>{
          let allRowsData_key = {};
          item['cell'].map((item1, key1)=>{
            allRowsData_key[item1['column']] = item1;
            // console.log('quarterlyReviewData >>>> ', item1, key1);
          })
          allRowsData_row.push(allRowsData_key);
        });
        console.log('quarterlyReviewData >>>> ', allRowsData_row);
  
        setQuarterlyReviewData({
          header:mColArr,
          tableBody:allRowsData_row
        })
      }


    }
    
  }, [quarterlyReviewLoading])


  if(quarterlyReviewLoading){
    return <CircularProgress />
    
  }

  return (
    <Box>
      

      { quarterlyReviewData.header && 
        QuarterlyReviewData.header.length > 0 ?
        <>
        
        <TableContainer sx={{ maxHeight: '80vh', maxWidth: '1000px' }}>
          <Table stickyHeader aria-label="sticky table" className="qr-table custom-table" id="table-to-xls">
            <TableHead>
            <TableRow hover role="checkbox" tabIndex={-1} >
                {
                    QuarterlyReviewData.header.map((column, cKey)=>{
                      let cStyle = {}; 
                      let valueRow = column.extra;
                      let value = column.label;
                      cStyle = {...cStyle, backgroundColor:valueRow?.bgColor, color:valueRow?.textColor};
                      return (
                        <TableCell className='text-ellipsis' style={cStyle} key={column.id} align={column.align} >
                          {column?.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      )
                    })
                  }
            </TableRow>
            </TableHead>
            <TableBody>
            {
              QuarterlyReviewData.tableBody.map((row, rKey)=>{
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={'rKey__'+rKey}>
                    {
                      QuarterlyReviewData.header.map((column, cKey)=>{
                        let cStyle = {}; 
                        let valueRow = row[column.id]; 
                        let value = valueRow.value;
                        cStyle = {...cStyle, backgroundColor:valueRow.bgColor, color:valueRow.textColor};
                        return (
                          <TableCell className='text-ellipsis' style={cStyle} key={column.id} align={column.align} >
                            {column?.format && typeof value === 'number'
                              ? column.format(value)
                              : value}
                          </TableCell>
                        )
                      })
                    }
                  </TableRow>
                )
              })
            }
            </TableBody>
          </Table>
        </TableContainer>
        </>
        :
        <>
          {/* <CircularProgress /> */}
          <Typography>
            To Be Updated.
          </Typography>

        </>
      }

    </Box>
  )
}

export default QuarterlyReview